/**
 * Site configuration
 * Centralized place for site-wide settings and links
 */

export const siteConfig = {
  name: "Jordan Florchinger",
  title: "JORDAN FLORCHINGER",
  description: "I am a jack of all trades when it comes to technology. I've done everything from software development and system administration to embedded hardware and software.",
  tagline: "and I like to create stuff",

  social: {
    github: "https://github.com/jflorchi",
    linkedin: "https://www.linkedin.com/in/jordan-florchinger",
    email: "jordan.florchinger@alumni.uleth.ca"
  },

  routes: {
    home: "/",
    projects: "/projects"
  }
};
